import { jsxs as a, jsx as c } from "react/jsx-runtime";
import { twMerge as r } from "tailwind-merge";
import { CheckCheckboxIcon as b } from "../../icons/check-checkbox-icon.mjs";
import { FieldErrorAndDescription as u } from "../form/field-error-and-description.mjs";
const A = ({
  inputRef: i,
  error: n,
  description: s,
  value: e,
  onChange: p,
  label: o,
  disabled: t,
  isFetching: d,
  labelClassName: m,
  className: x,
  errorClassName: l,
  descriptionClassName: k,
  checkboxIconClassName: h,
  inputClassName: y,
  inputWrapperClassName: g
}) => /* @__PURE__ */ a(
  "label",
  {
    className: r(
      "group flex w-fit items-center gap-3",
      t ? "cursor-default" : "cursor-pointer",
      x
    ),
    "aria-checked": e,
    children: [
      /* @__PURE__ */ a("div", { className: r("relative flex items-center justify-center", g), children: [
        /* @__PURE__ */ c(
          "input",
          {
            ref: i,
            disabled: t,
            checked: e,
            className: r(
              "peer/checkbox main-transition-colors",
              t ? "bg-skeleton-primary/40 border-darkgray/20 checked:bg-text-primary/60 checked:border-text-primary/75 cursor-default" : "border-darkgray bg-background-secondary checked:border-text-primary checked:bg-text-primary",
              d && "animate-pulse",
              "focus-ring h-[20px] w-[20px] cursor-pointer appearance-none rounded-md border",
              y
            ),
            type: "checkbox",
            onChange: (f) => p(f.target.checked)
          }
        ),
        /* @__PURE__ */ c(
          b,
          {
            className: r(
              "absolute",
              t ? e ? "fill-background-secondary/70 opacity-100" : "opacity-0" : "fill-background-secondary opacity-100",
              h
            )
          }
        )
      ] }),
      o && /* @__PURE__ */ c(
        "span",
        {
          className: r(
            "main-transition-colors",
            e ? "text-text-primary" : "text-text-primary/50",
            "leading-5",
            m,
            "text-left"
          ),
          children: o
        }
      ),
      /* @__PURE__ */ c(
        u,
        {
          description: s,
          error: n,
          errorClassName: l,
          descriptionClassName: k
        }
      )
    ]
  }
);
export {
  A as Checkbox
};
